/* Bright Solar Lights — dropdown on “The range” in the top navigation.
   Solar Lights, Solar Fans and CCTV each go to their own collection page.

   Solar Lights points at /collections/solar-lights, not street-lights.
   street-lights is tag-driven and only ever contained the street lights,
   so the garden lamp, ceiling light, wall light and flood light were all
   missing from a menu item called Solar Lights. solar-lights is
   rule-driven on product type and picks up every light in the catalogue.

   The header is rendered by the ported React app, so instead of wrapping
   the link (which React would undo on its next render) the panel lives on
   <body> and is positioned under the link. Listeners are re-attached on
   each observer pass via a data flag. */
(function () {
  var STYLE_ID = "bsl-nav-style-v1";
  var PANEL_ID = "bsl-nav-panel";
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MUTED = "#6E7268";

  var ITEMS = [
    { label: "Solar Lights", sub: "Street, flood, garden and security lights", href: "/collections/solar-lights" },
    { label: "Solar Fans", sub: "Off-grid cooling, panel included", href: "/collections/solar-fans" },
    { label: "CCTV", sub: "Solar and wired security cameras", href: "/collections/cctv" },
    { label: "Fields & Farms", sub: "Yards, gateways and paddocks", href: "/collections/fields-farms" },
    { label: "Shop all", sub: "Everything in the range", href: "/collections/all" }
  ];

  var closeTimer = null;

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "#" + PANEL_ID + "{position:fixed;z-index:9999;min-width:19rem;background:#fff;" +
        "border:1px solid rgba(23,26,21,.08);border-radius:16px;" +
        "box-shadow:0 22px 60px rgba(23,26,21,.18);padding:.55rem;" +
        "font-family:Inter,system-ui,sans-serif;opacity:0;visibility:hidden;" +
        "transform:translateY(-6px);transition:opacity .18s ease,transform .18s ease,visibility .18s}",
      "#" + PANEL_ID + ".open{opacity:1;visibility:visible;transform:translateY(0)}",
      "#" + PANEL_ID + " a{display:block;padding:.7rem .85rem;border-radius:11px;" +
        "text-decoration:none;color:" + INK + ";transition:background .16s ease}",
      "#" + PANEL_ID + " a:hover,#" + PANEL_ID + " a:focus-visible{background:#EEF0EB;outline:none}",
      "#" + PANEL_ID + " b{display:block;font-size:.92rem;font-weight:700;line-height:1.25}",
      "#" + PANEL_ID + " span{display:block;margin-top:.15rem;font-size:.78rem;" +
        "line-height:1.4;color:" + MUTED + "}",
      "#" + PANEL_ID + " a:hover b{color:" + GOLD + "}",
      "@media(max-width:820px){#" + PANEL_ID + "{display:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function panel() {
    var p = document.getElementById(PANEL_ID);
    if (p) return p;
    p = document.createElement("div");
    p.id = PANEL_ID;
    p.setAttribute("role", "menu");
    p.innerHTML = ITEMS.map(function (i) {
      return (
        '<a role="menuitem" href="' + i.href + '">' +
        "<b>" + i.label + "</b><span>" + i.sub + "</span></a>"
      );
    }).join("");
    p.addEventListener("mouseenter", cancelClose);
    p.addEventListener("mouseleave", scheduleClose);
    document.body.appendChild(p);
    return p;
  }

  function findLink() {
    var as = document.querySelectorAll("header a, nav a");
    for (var i = 0; i < as.length; i++) {
      var t = (as[i].textContent || "").trim();
      if (/^the range$/i.test(t)) return as[i];
    }
    return null;
  }

  function open(link) {
    cancelClose();
    var p = panel();
    var r = link.getBoundingClientRect();
    p.style.top = Math.round(r.bottom + 10) + "px";
    var left = Math.round(r.left);
    var max = window.innerWidth - p.offsetWidth - 16;
    p.style.left = Math.max(16, Math.min(left, max)) + "px";
    p.classList.add("open");
    link.setAttribute("aria-expanded", "true");
  }

  function close() {
    var p = document.getElementById(PANEL_ID);
    if (p) p.classList.remove("open");
    var l = findLink();
    if (l) l.setAttribute("aria-expanded", "false");
  }

  function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
  function scheduleClose() { cancelClose(); closeTimer = setTimeout(close, 220); }

  function wire() {
    var link = findLink();
    if (!link || link.dataset.bslNav) return;
    link.dataset.bslNav = "1";
    link.setAttribute("aria-haspopup", "true");
    link.setAttribute("aria-expanded", "false");

    link.addEventListener("mouseenter", function () { open(link); });
    link.addEventListener("mouseleave", scheduleClose);
    link.addEventListener("focus", function () { open(link); });

    /* touch: first tap opens the menu rather than jumping to the section */
    link.addEventListener("click", function (e) {
      var p = document.getElementById(PANEL_ID);
      var isOpen = p && p.classList.contains("open");
      if (window.matchMedia("(hover: none)").matches && !isOpen) {
        e.preventDefault();
        open(link);
      }
    });

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    document.addEventListener("click", function (e) {
      var p = document.getElementById(PANEL_ID);
      if (!p) return;
      if (e.target === link || link.contains(e.target) || p.contains(e.target)) return;
      close();
    });
    window.addEventListener("scroll", function () {
      var p = document.getElementById(PANEL_ID);
      if (p && p.classList.contains("open")) open(link);
    }, { passive: true });
    window.addEventListener("resize", close);
  }

  function run() { styles(); wire(); }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
